import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {FlightMode} from "../../FlightMode";

import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {BasedCountUp} from "../BasedCountUp";
import {FlightModeGameAssets} from "../../FlightModeGameAssets";
import {WinConfigUtilBased} from "../../misc/WinConfigUtil";
import {SpineGSAPWrapper} from "../../misc/SpineGSAPWrapper";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class FlightModeWinView extends PIXI.Container implements StageLayer {
    private basedCountUp:BasedCountUp;
    private bigWinAnimation:PIXI.spine.Spine;
    private blackOut:PIXI.Sprite;
    private isBigWin:boolean;

    constructor() {
        super();
        this.name = "FlightModeWinView";

        this.blackOut = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.blackOut.name = "blackOut";
        this.blackOut.tint = PIXI.utils.string2hex("#0000ff");
        this.blackOut.position.set(360,360);
        this.blackOut.anchor.set(0.5,0.5);
        this.blackOut.alpha = 0;

        this.bigWinAnimation = new PIXI.spine.Spine(FlightMode.assetLoader.getSpineAsset(FlightModeGameAssets.BIG_WIN_SPINE));
        this.bigWinAnimation.position.set(360, 360);

        this.basedCountUp = new BasedCountUp();
        this.basedCountUp.position.set(360, 250);

        this.addChild(this.blackOut);
        this.addChild(this.bigWinAnimation);
        this.addChild(this.basedCountUp);

        this.onResize();
    }

    // why is there no branch for when its not a big win
    private moveWinCountup() {
        if (this.isBigWin) {
            if (NolimitApplication.isLandscape) {
                this.basedCountUp.position.set(360, 520);
            } else {
                this.basedCountUp.position.set(360, 650);
            }
        }
    }

    public onResize() {
        this.blackOut.width = NolimitApplication.screenBounds.width;
        this.blackOut.height = NolimitApplication.screenBounds.height;
        this.moveWinCountup();
    }
    public clear(): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.basedCountUp.position.set(360, 250);
                this.basedCountUp.hide();
            })
    }

    public showAfterMaxWin(win:number):gsap.core.Timeline {
       return gsap.timeline().add(this.basedCountUp.showNoFade(win));
    }

    public showIndividualWin(amount:number, multiplier:number, waysCount:number, reel:number, row:number) {
        const startX = (reel + 0.5) * 120;
        const startY = (row + 0.5) * 148 + 84;

        const winText = new PIXI.BitmapText(
            multiplier > 1
                ? `${SlotGame.apiPlugin.currency.formatValue(amount)}X${multiplier}`
                : `${SlotGame.apiPlugin.currency.formatValue(amount)}`,
            {
                fontName: FlightModeGameAssets.BITMAP_FONT_WIN_COUNT_UP,
                fontSize: 30,
            }
        );
        const winTextScale = 110 / winText.width < 1 ? 110 / winText.width : 1;
        winText.scale.set(winTextScale, winTextScale);
        //winText.position.set(0, -10);
        winText.anchor = 0.5;

        const wayOrWays = waysCount > 1 ? "Ways" : "Way"
        const ways = new PIXI.Text(`${waysCount} ${FlightMode.apiPlugin.translations.translate(wayOrWays)}`, {
            fill: "#fffb00",
            fontFamily: "Helvetica",
            fontSize: 50,
            fontStyle: "oblique",
            fontWeight: "bolder",
            lineJoin: "round",
            strokeThickness: 8
        })
        const waysScale = 110 / ways.width < 1 ? 110 / ways.width : 1;
        ways.scale.set(waysScale, waysScale);
        ways.anchor.set(0.5, 0.5);
        ways.position.set(0, 60);

        const textContainer = new PIXI.Container();
        textContainer.addChild(winText);
        textContainer.addChild(ways);
        textContainer.position.set(startX, startY);
        //const textScale = 160 / textContainer.width;
        //textContainer.scale.set(textScale, textScale);

        return gsap.timeline()
            .add(() => {
                this.addChild(textContainer)
            })
            .add(gsap.to(textContainer.position, {y: startY - 84, duration: 0.5}))
            .add(gsap.to(textContainer, {alpha: 0, duration: 0.1}))
            .add(() => {
                textContainer.removeChild(winText);
                textContainer.removeChild(ways);
                winText.destroy();
                ways.destroy();
                this.removeChild(textContainer);
                textContainer.destroy();
            })
    }


    public countUpWin(to:number, from:number = 0, duration = 1):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.basedCountUp.position.set(360, 250);
            })
            .add(duration > 0
                 ? this.basedCountUp.countUp(to, from, duration)
                 : this.basedCountUp.countUpInstant(to, from))
            .add(this.basedCountUp.hide(), '>0.6')
    }

   public bigWinStart(to:number, from:number, level:number):gsap.core.Timeline  {
       return gsap.timeline()
           .add(() => {
               this.isBigWin = true;
               this.moveWinCountup();
           })
           .add(gsap.to(this.blackOut, {alpha: 0.8, duration:0.1}), '<')
           .add(gsap.to(this.bigWinAnimation, {alpha: 1, duration:0.1}), '<')
           .add(() => {
               this.bigWinAnimation.state.setAnimation(0, `BW_${level}_Loop`, true);
           }, "<")
           .add(this.basedCountUp.countUp(to, from, WinConfigUtilBased.bigLevels[level - 1].duration), '<')
   }

    public bigWinMiddle(to:number, from:number, level:number):gsap.core.Timeline {
        return gsap.timeline()
            .add(this.basedCountUp.countUpNoFade(to, from, WinConfigUtilBased.bigLevels[level - 1].duration))
            .add(level == 5 ? SpineGSAPWrapper.createTimeline(this.bigWinAnimation, 0, "BW_5") : () => {}, '<')
            .add(() => {
                this.bigWinAnimation.state.setAnimation(0, `BW_${level}_Loop`, true);
            }, level == 5 ? ">" : '<')
    }

    public bigWinEnd(level:number):gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.basedCountUp.position, {y: 250, duration: 0.7}))
            .add(this.basedCountUp.hide(), '>1.2')
            .add(gsap.to(this.bigWinAnimation, {alpha: 0, duration:0.1}))
            .add(gsap.to(this.blackOut, {alpha: 0, duration:0.1}), '<')
            .add(() => {
                this.bigWinAnimation.state.setEmptyAnimation(0, 0)
                this.isBigWin = false;
            });
    }
}